import { render } from "./teacherlist.vue?vue&type=template&id=055d44e4"
import script from "./teacherlist.vue?vue&type=script&lang=js"
export * from "./teacherlist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__